// @flow
import { useQuery, type QueryResult } from 'react-query';

import useClientId from 'common/hooks/useClientId';
import { FilterBuilder, FilterOperation } from 'common/models/internal/Filter';
import FilterListBuilder from 'common/models/helpers/FilterListBuilder';

// eslint-disable-next-line max-len
import { quoteSelectionConfigSearch as quoteSelectionConfigSearchApi } from 'platform/settings/modules/orchestration/api';

type Options = {
    onError?: (error: Error) => void
};

const useGetRulesCount = ({ onError }: Options): QueryResult<number> => {
    const clientId = useClientId();

    const filters = new FilterListBuilder()
        .addAll([
            new FilterBuilder()
                .withName('status')
                .withOperation(FilterOperation.Equals)
                .withValue('ACTIVE')
        ])
        .build();

    return useQuery({
        queryKey: ['client', clientId, 'ruleset', 'search', { filters }],
        queryFn: async () => {
            const {
                paginationInfo: { total }
            } = await quoteSelectionConfigSearchApi.post(
                { clientId },
                { filters }
            );

            return total;
        },
        onError
    });
};

export default useGetRulesCount;
